import React from 'react'

const Back = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <defs>
      <filter id="back_svg__a" width="115%" height="183.1%" x="-7.5%" y="-41.5%" filterUnits="objectBoundingBox">
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={6} />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0.101960784 0 0 0 0 0.203921569 0 0 0 0 0.309803922 0 0 0 0.1 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" filter="url(#back_svg__a)" transform="translate(-16 -22)">
      <path
        fill={props.fill || '#7D92A9'}
        fillRule="nonzero"
        d="M36 33H22.36l5.74-5.73a1 1 0 10-1.42-1.41l-7.34 7.34a1.15 1.15 0 000 1.61l7.34 7.34a.997.997 0 001.42 0 1 1 0 000-1.41L22.37 35H36a1 1 0 000-2z"
      />
    </g>
  </svg>
)

export default Back
